module.exports = __webpack_public_path__ + "static/media/goldenprize-sardine-th.e0208aa4.png";